import LLTrendingNow from '@/locales/TrendingNow/en';
import LLEdito from '@/locales/Edito/en';
import LLTravel from '@/locales/Travel/en';
import LLFuture from '@/locales/Future/en';
import LLArty from '@/locales/Arty/en';
import LLKeyReport from '@/locales/KeyReport/en';
import LLPioneer_Rochat from '@/locales/Pioneer_Rochat/en';
import LLPioneer_Chokron from '@/locales/Pioneer_Chokron/en';
import LLBack from '@/locales/Back/en';
import LLProfiting from '@/locales/Profiting/en';
import LLLegal from '@/locales/Legal/en';

export const  en = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoFR: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoLU: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoMC: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoUK: {
            segment: 'editorial',
            title: 'Editorial',
        },
        Essential: {
            segment: 'essentials',
            title: 'Essentials',
        },
        TrendingNow: {
            segment: 'trends-notebook',
            title: 'Trends notebook',
        },
        Travel: {
            segment: 'paper-trips-literary-epics',
            title: 'Paper trips, literary epics',
        },
        Future: {
            segment: 'portrait-metaverse-real-world',
            title: 'Portrait of the metaverse in the real world',
        },
        Arty: {
            segment: 'ceramics-art-on-fire',
            title: 'Ceramics: an art on fire',
        },
        KeyReport: {
            segment: 'sun-also-rises-african-energy',
            title: 'The sun also rises on African energy',
        },
        Pioneer_Rochat: {
            segment: 'nicolas-rochat-dressing-sustainable-workout',
            title: 'Nicolas Rochat: Dressing up for a sustainable workout',
        },
        Pioneer_Chokron: {
            segment: 'sylvie-chokron-giving-healthy-scientifically-proven',
            title: 'Sylvie Chokron: Giving is healthy, and it’s scientifically proven!',
        },
        Back: {
            segment: 'thirty-years-agro-first-steps-qr-code',
            title: '30 years ago: the first steps of the QR Code',
        },
        Profiting: {
            segment: 'company-with-mission',
            title: 'A company with a mission',
        },
        Legal: {
            segment: 'credits-legal-information',
            title: 'Credits & legal information',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    EditoCH: LLEdito,
    EditoFR: LLEdito,
    EditoLU: LLEdito,
    EditoMC: LLEdito,
    EditoUK: LLEdito,

    TrendingNow: LLTrendingNow,

    Travel: LLTravel,

    Future: LLFuture,

    Arty: LLArty,

    KeyReport: LLKeyReport,

    Pioneer_Rochat: LLPioneer_Rochat,

    Pioneer_Chokron: LLPioneer_Chokron,

    Back: LLBack,

    Profiting: LLProfiting,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Towards a more engaged world with <br />Societe&nbsp;Generale Private&nbsp;Banking',
        logoBaseLineKH: 'Towards a more engaged world with <br />Kleinwort&nbsp;Hambros',
        logoDate: 'Summer 2022 #8',
        title: 'The sun also rises on <br/>african energy',
        artitle1title: `Portrait of the metaverse <br/>in the real world`,
        artitle2title: `Pioneer spirits: <br/>Nicolas&nbsp;Rochat and Sylvie&nbsp;Chokron`,
        artitle3title: `Paper trips, <br/>literacy epics`,
    },

    next: 'Next: ',

    welcome_message : 'EN - Welcome to Your Vue.js App',
    popular_links : 'EN - Popular Links',
    ecosystem : 'EN - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ',',
    counterUpDecimal: '.',
};
